import * as React from 'react';
import PropTypes from 'prop-types';
import {Subbar, Title, PageHeader} from "ah-tools";
import {translate} from "react-i18next";
import {Button, Confirm, Icon, Message, Popup, Table} from "semantic-ui-react";
import moment from '../misc/moment';
import {DATE_FORMAT} from "../misc/vars";

class ModuleList extends React.Component {
	static propTypes = {
		modules: PropTypes.array.isRequired,
		isUpdating: PropTypes.func.isRequired,
		onAdapt: PropTypes.func.isRequired,
		onLoad: PropTypes.func.isRequired
	};
	static defaultProps = {
		modules: []
	};
	state = {
		confirm: null
	};
	
	adapt = (module) => this.setState({
		confirm: () => this.props.onAdapt(module, () => this.setState({confirm: null}))
	});
	
	render = () => {
		const {modules, t, isUpdating} = this.props;
		return (
			<div>
				<PageHeader align={Subbar.ALIGN_BETWEEN}>
					<Title>Module</Title>
					{/*<Subbar>
						<Popup
							content={'Neues Modul anlegen'}
							position={'left center'}
							inverted={true}
							trigger={
								<IconButton onClick={() => push(ROUTE_MODULES_CREATE)}>
									<Icon name={'plus'} size={'large'} />
								</IconButton>
							}
						/>
						
					</Subbar>*/}
				</PageHeader>
				<Message
					info={true}
					header={'Hinweis'}
					icon={<Icon name={'info'}/>}
					content={'Module können nicht dynamisch erstellt werden. Hier werden sie nur zur Übersicht angezeigt.'}
				/>
				<Table celled selectable>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell>ID</Table.HeaderCell>
							<Table.HeaderCell>Name</Table.HeaderCell>
							<Table.HeaderCell>Standart</Table.HeaderCell>
							<Table.HeaderCell>Beschreibung</Table.HeaderCell>
							<Table.HeaderCell>Häuser zugeordnet</Table.HeaderCell>
							<Table.HeaderCell>Häuser total</Table.HeaderCell>
							<Table.HeaderCell>Zuletzt geändert</Table.HeaderCell>
							<Table.HeaderCell>&nbsp;</Table.HeaderCell>
						</Table.Row>
					</Table.Header>
					<Table.Body>
						{modules.map(module =>
							<Table.Row key={module.module_id}>
								<Table.Cell>{module.module_id}</Table.Cell>
								<Table.Cell>{t([`modules.name.module-${module.module_id}`, module.name])}</Table.Cell>
								<Table.Cell><Icon name={module.default ? 'checkmark box' : 'close'}/></Table.Cell>
								<Table.Cell>{t([`modules.desc.module-${module.module_id}`, 'modules.no-desc'])}</Table.Cell>
								<Table.Cell>{module.houses}</Table.Cell>
								<Table.Cell>{module.total_houses}</Table.Cell>
								<Table.Cell>{moment(module.updated_at).format(DATE_FORMAT)}</Table.Cell>
								<Table.Cell>{module.default && module.houses < module.total_houses ?
									<Popup inverted content={t('modules.adapt')} trigger={<Button loading={isUpdating(module)} onClick={() => this.adapt(module)} primary compact>Ausgleichen</Button>}/> : null}
								</Table.Cell>
							</Table.Row>
						)}
					</Table.Body>
				</Table>
				<Confirm
					content={t('confirm.sure')}
					open={null !== this.state.confirm}
					onCancel={() => this.setState({confirm: null})}
					onConfirm={this.state.confirm}
					confirmButton={t('actions.yes')}
					cancelButton={t('actions.no')}
				/>
			</div>
		);
	};
}

export default translate()(ModuleList);


// WEBPACK FOOTER //
// ./src/components/ModuleList.js